import React, { useEffect, useState } from 'react';
import { Snackbar as MuiSnackbar } from '@mui/material';
import { Alert } from '@mui/material';

type Props = {
  open: boolean;
  message: string;
  severity?: 'success' | 'info' | 'warning' | 'error';
  autoHideDuration?: number;
  onClose?: () => void;
};

const SnackbarComponent: React.FC<Props> = ({
    open,
    message,
    severity = 'info',
    autoHideDuration = 3000,
    onClose,
}) => {
    const [visible, setVisible] = useState(open);

    useEffect(() => {
        setVisible(open);
    }, [open]);

    const handleClose = (
        event?: React.SyntheticEvent | Event,
        reason?: string,
    ) => {
        if (reason === 'clickaway') return;
        setVisible(false);
        onClose?.();
    };

    return (
        <MuiSnackbar
            open={visible}
            autoHideDuration={autoHideDuration}
            onClose={handleClose}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
            <Alert
                onClose={handleClose}
                severity={severity}
                elevation={6}
                variant={'filled'}
            >
                {message}
            </Alert>
        </MuiSnackbar>
    );
};

export default SnackbarComponent;
